import { API_BASE_URL } from '../../../lib/api';
import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '@/lib/tenantHeaders';

/**
 * Ofertas al cliente del módulo LCL.
 *
 * Los headers se construyen dentro de cada función: hacerlo al importar
 * congela el token y el slug del tenant de la primera carga.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

export async function listLclOfertas(lclRequestId) {
  const res = await apiFetch(
    `${API_BASE_URL}/lcl-ofertas/by-request/${lclRequestId}`,
    { headers: withTenant() },
  );
  if (!res.ok) throw new Error('No se pudieron cargar las ofertas');
  return res.json();
}

export async function getLclOferta(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}`, {
    headers: withTenant(),
  });
  return res.json();
}

export async function createLclOferta(payload) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

/** Arma la oferta clonando los conceptos de cotizaciones ya cargadas. */
export async function crearDesdeCotizacion(payload) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/desde-cotizacion`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateLclOferta(id, payload) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteLclOferta(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
}

export async function setEstadoLclOferta(id, estado, notasRespuesta) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/estado`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ estado, notasRespuesta }),
  });
  return res.json();
}

export async function nuevaVersionLclOferta(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/nueva-version`, {
    method: 'POST',
    headers: jsonHeaders(),
  });
  return res.json();
}

/**
 * Recalcula en el servidor sin persistir.
 *
 * El editor muestra estos totales y no los suyos: así lo que se ve
 * mientras se edita es exactamente lo que se va a guardar e imprimir.
 */
export async function previewCalculoOferta(payload) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/preview-calculo`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

/** Genera el PDF, lo sube a R2 y devuelve la URL firmada. */
export async function generarPdfOferta(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/pdf`, {
    method: 'POST',
    headers: jsonHeaders(),
  });
  return res.json();
}

export async function getPdfUrlOferta(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/pdf`, {
    headers: withTenant(),
  });
  return res.json();
}

/**
 * Trae el PDF como object URL para mostrarlo en un `<iframe>`.
 *
 * No se le puede pasar la URL directa al iframe: el navegador la pide
 * por su cuenta y **no manda el header `X-Tenant`**, así que el backend
 * no sabe de qué operador se trata y responde 404. Se pide con
 * `apiFetch` (que sí manda los headers) y se arma un blob local.
 *
 * El llamador DEBE liberar la URL con `URL.revokeObjectURL` al
 * desmontar, o el blob queda en memoria.
 */
export async function fetchPreviewPdfUrl(id) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/pdf/preview`, {
    headers: withTenant(),
  });
  if (!res.ok) {
    let msg = 'No se pudo generar la vista previa';
    try {
      msg = (await res.json())?.message || msg;
    } catch {
      /* la respuesta de error puede no ser JSON */
    }
    throw new Error(msg);
  }
  return URL.createObjectURL(await res.blob());
}

export async function enviarLclOferta(id, payload) {
  const res = await apiFetch(`${API_BASE_URL}/lcl-ofertas/${id}/enviar`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}
